export const POSITION = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left",
  ALL: ["bottom", "left", "top", "right"]
};

export const THEME = {
  LARGE: "large",
  SMALL: "small"
};

export const TRIGGER = {
  HOVER: "hover",
  CLICK: "click"
};

export const KEYPRESS = {
  ESCAPE: "escape",
  ENTER: "enter"
};
